(() => {
  const bar = document.querySelector('[data-bpc-market-bar]');
  const regionModeKey = 'bpcRegionMode:v1';
  const currencyConfig = document.querySelector('[data-bpc-currency-engine]');
  let storedRegionMode = '';

  try {
    storedRegionMode = window.localStorage.getItem(regionModeKey) || '';
  } catch (error) {
    storedRegionMode = '';
  }

  /*
   * This preflight runs immediately in the earlier deferred script, before the
   * later currency engine reads its data attribute.
   */
  if (bar && (bar.dataset.bpcActualEu === 'true' || storedRegionMode === 'eu')) {
    if (currencyConfig) currencyConfig.dataset.bpcCurrency = 'EUR';
    bar.dataset.bpcPresentation = 'eu';
  }

  const ready = (callback) => document.readyState === 'loading'
    ? document.addEventListener('DOMContentLoaded', callback, { once: true })
    : callback();

  ready(() => {
    const messages = bar ? [...bar.querySelectorAll('[data-bpc-market-message]')] : [];
    const mobileQuery = window.matchMedia?.('(max-width: 749px)');
    const reducedMotionQuery = window.matchMedia?.('(prefers-reduced-motion: reduce)');
    const euRegionButton = bar?.querySelector('[data-bpc-region-mode="eu"]');
    let activeIndex = 0;
    let rotationTimer;

    const setText = (selector, value) => {
      const element = bar?.querySelector(selector);
      if (element) element.textContent = value;
    };

    const euPresentation = bar?.dataset.bpcPresentation === 'eu';

    if (euPresentation && bar) {
      setText('[data-bpc-selector-desktop]', 'European Union (English)');
      setText('[data-bpc-selector-mobile]', 'EU (EN)');
      setText('[data-bpc-selector-currency]', 'EUR');
      setText('[data-bpc-current-summary]', 'European Union (English) · EUR');
      euRegionButton?.setAttribute('aria-pressed', 'true');
    }

    euRegionButton?.addEventListener('click', () => {
      try {
        window.localStorage.setItem(regionModeKey, 'eu');
      } catch (error) {}
      window.location.reload();
    });

    bar?.querySelectorAll('form[action*="/localization"]').forEach((form) => {
      form.addEventListener('submit', () => {
        try {
          window.localStorage.removeItem(regionModeKey);
        } catch (error) {}
      });
    });

    const stopRotation = () => {
      if (rotationTimer) {
        window.clearInterval(rotationTimer);
        rotationTimer = undefined;
      }
    };

    const showAllMessages = () => {
      stopRotation();
      bar?.classList.remove('is-rotating');
      messages.forEach((message) => {
        message.classList.remove('is-active');
        message.setAttribute('aria-hidden', 'false');
      });
    };

    const showActiveMessage = () => {
      messages.forEach((message, index) => {
        const active = index === activeIndex;
        message.classList.toggle('is-active', active);
        message.setAttribute('aria-hidden', String(!active));
      });
    };

    const syncMessageRotation = () => {
      if (!bar || messages.length < 2 || !mobileQuery || !reducedMotionQuery) return;

      stopRotation();

      if (!mobileQuery.matches || reducedMotionQuery.matches) {
        showAllMessages();
        return;
      }

      bar.classList.add('is-rotating');
      showActiveMessage();
      rotationTimer = window.setInterval(() => {
        activeIndex = (activeIndex + 1) % messages.length;
        showActiveMessage();
      }, 9000);
    };

    const addMediaListener = (mediaQuery, callback) => {
      if (typeof mediaQuery?.addEventListener === 'function') {
        mediaQuery.addEventListener('change', callback);
      } else if (typeof mediaQuery?.addListener === 'function') {
        mediaQuery.addListener(callback);
      }
    };

    addMediaListener(mobileQuery, syncMessageRotation);
    addMediaListener(reducedMotionQuery, syncMessageRotation);
    document.addEventListener('visibilitychange', () => {
      if (document.hidden) {
        stopRotation();
      } else {
        syncMessageRotation();
      }
    });
    syncMessageRotation();

    const shippingSummary = document.querySelector('.template-product .product__tax');
    if (shippingSummary && bar) {
      const ddp = bar.dataset.bpcDdp === 'true';
      shippingSummary.classList.add('bpc-product-shipping-summary');
      shippingSummary.innerHTML = `
        <span><strong>Free worldwide shipping</strong></span>
        <span>${ddp ? 'Duties &amp; import taxes prepaid' : 'Import charges may apply'}</span>
        <span><a href="/pages/shipping-delivery">Shipping details</a></span>
      `;
    }
  });
})();
